import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex shrink-0 items-center justify-center overflow-hidden rounded border border-gray-200 bg-white" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = {
  key: 1,
  class: "px-1 text-center text-xs text-gray-500"
}

import { ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ReplacementProductPhoto',
  props: {
    src: {},
    reference: {}
  },
  setup(__props: any) {

const props = __props;
const failed = ref(false);
watch(() => props.src, () => { failed.value = false; });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (_ctx.src && !failed.value)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _ctx.src,
          alt: _ctx.reference || '',
          class: "h-full w-full object-contain",
          loading: "lazy",
          referrerpolicy: "no-referrer",
          onError: _cache[0] || (_cache[0] = ($event: any) => (failed.value = true))
        }, null, 40, _hoisted_2))
      : (_openBlock(), _createElementBlock("span", _hoisted_3, "Photo indisponible"))
  ]))
}
}

})